import { cn } from "../lib/utils.js";
import { CircleNotch } from "@phosphor-icons/react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/loader.tsx
const iconSizeMap = {
	sm: "tw:size-4",
	md: "tw:size-6",
	lg: "tw:size-8"
};
const Loader = ({ className, message, size = "md", ...props }) => {
	return /* @__PURE__ */ jsxs("div", {
		"data-slot": "loader",
		className: cn("tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-3 tw:text-center", className),
		...props,
		children: [/* @__PURE__ */ jsx(CircleNotch, {
			className: cn("tw:animate-spin tw:text-primary-purple", iconSizeMap[size]),
			weight: "bold"
		}), message && /* @__PURE__ */ jsx("p", {
			className: "tw:m-0 tw:text-sm tw:text-midnight",
			children: message
		})]
	});
};
//#endregion
export { Loader };

//# sourceMappingURL=loader.js.map